import { useState } from 'react';
import { useMutation } from '@apollo/client/react';
import { Link, LinkProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useApolloError } from 'common/hooks/useApolloError';
import { CreateBillingPortalUrlDocument } from 'graphql/types';
import { LoaderOverlay } from 'common/components/Loader';
import { ERROR_MESSAGES } from 'common/constants/errorMessages';
import { useSnackbar } from 'common/hooks/useSnackbar';

interface IProps extends LinkProps {
    children?: React.ReactNode;
}

export const BillingPortalLink = (props: IProps) => {
    const [translate] = useTranslation();
    const { showApolloError } = useApolloError();
    const [displaySnackbar] = useSnackbar();
    const [showLoader, setShowLoader] = useState(false);
    const [createBillingPortalUrl] = useMutation(
        CreateBillingPortalUrlDocument
    );

    const handleClick = async () => {
        if (showLoader) return;

        setShowLoader(true);

        let url;

        try {
            const { data } = await createBillingPortalUrl({
                variables: {
                    returnUrl: window.location.href,
                },
            });
            url = data?.createBillingPortalUrl?.url;
        } catch (error) {
            showApolloError(error);
            setShowLoader(false);

            return;
        }

        if (url) {
            window.location.href = url;
            // Wait for the page to load before hiding the loader
            setTimeout(() => {
                setShowLoader(false);
            }, 1000);
        } else {
            // If we dont have a url we want to show an error message
            displaySnackbar(ERROR_MESSAGES.BillingPortalInvalidRequest, {
                variant: 'error',
            });
            setShowLoader(false);
        }
    };

    return (
        <>
            <Link {...props} sx={{ cursor: 'pointer' }} onClick={handleClick} />
            <LoaderOverlay fadeIn visible={showLoader}>
                {translate('redirectingToBillingPortal')}
            </LoaderOverlay>
        </>
    );
};
